import React from 'react';
import Menu from "../components/menu";
import Footer from "../components/footer";

const Politique: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Menu />
      <div className="flex-1 container mx-auto p-6">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">Politique de confidentialité</h1>
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <section className="mb-8">
            <h2 className="text-3xl font-semibold text-gray-800 mb-4 flex items-center">
              Conditions d'Utilisation de TournoisPadel
            </h2>
            <p className="text-gray-700 leading-relaxed">
              1. <strong>Introduction</strong><br />
              Chez TournoisPadel, nous accordons une importance primordiale à la protection de vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre site web et nos services.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              2. <strong>Données Collectées</strong><br />
              Nous collectons différentes catégories de données personnelles pour assurer le bon fonctionnement de nos services :
              <ul className="list-disc list-inside ml-4">
                <li><strong>Données d'inscription :</strong> Nom, prénom, adresse e-mail, numéro de téléphone, mot de passe.</li>
                <li><strong>Données de profil utilisateur :</strong> Niveau de jeu, localisation, disponibilités, photo de profil.</li>
                <li><strong>Données transactionnelles :</strong> Informations de paiement (traitées de manière sécurisée via nos partenaires).</li>
              </ul>
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              3. <strong>Utilisation des Données</strong><br />
              Les données collectées sont utilisées pour :
                <li>Vous fournir un accès aux tournois et à la mise en relation avec d'autres joueurs.</li>
                <li>Vous envoyer des notifications concernant les nouveaux tournois.</li>
                <li>Gérer votre abonnement Premium.</li>
                <li>Améliorer nos services et personnaliser votre expérience utilisateur.</li>
                <li>Assurer la sécurité de notre plateforme.</li>
                <li>Répondre à vos questions ou réclamations via notre support client.</li>
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              4. <strong>Partage des Données</strong><br />
              Vos données personnelles ne seront jamais vendues à des tiers. Cependant, elles peuvent être partagées avec :
                <li><strong>Partenaires de service :</strong> pour le traitement des paiements, l’envoi de notifications ou l’hébergement de nos données.</li>
                <li><strong>Autorités légales :</strong> si la loi nous y oblige.</li>
            </p>
          </section>
          <hr className="my-8" />          
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              5. <strong>Vos Droits</strong><br />
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
              <li><strong>Accès :</strong>consulter les données que nous détenons sur vous.</li>
              <li><strong>Rectification :</strong>corriger des informations inexactes ou incomplètes.</li>
              <li><strong>Suppression :</strong>demander la suppression de vos données personnelles.</li>
              <li><strong>Portabilité :</strong>recevoir vos données dans un format utilisable.</li>
              <li><strong>Opposition :</strong>vous opposer à l’utilisation de vos données à des fins de marketing.</li>
              Pour exercer ces droits, veuillez nous contacter à l’adresse suivante : <a href="mailto:contact@tournois360.com" className="text-blue-500 underline">contact@tournoispadel.fr</a>.
            </p>
          </section>          
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              6. <strong>Durée de Conservation</strong><br />
              Vos données personnelles sont conservées aussi longtemps que nécessaire pour remplir les objectifs mentionnés dans cette politique ou pour satisfaire aux obligations légales.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              7. <strong>Modifications de la Politique</strong><br />
              Le traitement des données personnelles est régi par notre Politique de Confidentialité. En utilisant le site, vous acceptez que vos données soient collectées et utilisées conformément à cette politique.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              8. <strong>Modifications des Conditions d'Utilisation</strong><br />
              Nous pouvons être amenés à mettre à jour cette politique de confidentialité. En cas de changement majeur, vous serez informé(e) par e-mail ou via une notification sur notre site.
            </p>
          </section>
          <hr className="my-8" />
          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed">
              9. <strong>Contact</strong><br />
              Pour toute question ou préoccupation concernant cette politique de confidentialité, veuillez nous contacter : <a href="mailto:contact@tournois360.com" className="text-blue-500 underline">contact@tournoispadel.fr</a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Politique;